"use strict";

var _classCallCheck = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Base = require("../styles/Base");

var _Elements = require("../styles/Elements");

var _NewLaneTitleEditor = _interopRequireDefault(require("../widgets/NewLaneTitleEditor"));

var _v = _interopRequireDefault(require("uuid/v1"));

var NewLane = /*#__PURE__*/function (_react$Component) {
  _inherits(NewLane, _react$Component);

  var _super = _createSuper(NewLane);

  function NewLane() {
    var _this;

    _classCallCheck(this, NewLane);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "handleSubmit", function () {
      _this.props.onAdd({
        id: (0, _v.default)(),
        title: _this.getValue()
      });
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "getValue", function () {
      return _this.refInput.getValue();
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onClickOutside", function (a, b, c) {
      if (_this.getValue().length > 0) {
        _this.handleSubmit();
      } else {
        _this.props.onCancel();
      }
    });
    return _this;
  }

  _createClass(NewLane, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onCancel = _this$props.onCancel,
          t = _this$props.t;
      return _react.default.createElement(_Base.Section, null, _react.default.createElement(_Base.LaneTitle, null, _react.default.createElement(_NewLaneTitleEditor.default, {
        ref: function ref(_ref) {
          return _this2.refInput = _ref;
        },
        placeholder: t('placeholder.title'),
        onCancel: this.props.onCancel,
        onSave: this.handleSubmit,
        resize: "vertical",
        border: true,
        autoFocus: true
      })), _react.default.createElement(_Base.NewLaneButtons, null, _react.default.createElement(_Elements.AddButton, {
        onClick: this.handleSubmit
      }, t('button.Add lane')), _react.default.createElement(_Elements.CancelButton, {
        onClick: onCancel
      }, t('button.Cancel'))));
    }
  }]);

  return NewLane;
}(_react.Component);

NewLane.propTypes = {
  onCancel: _propTypes.default.func.isRequired,
  onAdd: _propTypes.default.func.isRequired,
  t: _propTypes.default.func.isRequired
};
NewLane.defaultProps = {};
var _default = NewLane;
exports.default = _default;